import { AxiosError } from "axios";
import { zEntityError } from "src/business/error/ZEntityError";
import z from "zod";

import { MfErrorsListStore } from "./components/MfErrorsListView";

/**
 * Общая точка для сохранения данных формы.
 * Требуется для того чтобы контролировать состояние ошибок.
 */
export const submitMForm = async <Result>(
  task: () => Promise<Result>,
  errorsStore: MfErrorsListStore,
): Promise<Result> => {
  errorsStore.clear();

  // если в ответе пришёл список ошибок, то его надо передать в форму как внешние ошибки
  const checkErrors = (someData: unknown) => {
    const errInfo = zWithErrors.safeParse(someData);
    if (errInfo.success) {
      errorsStore.form.setExternalErrors(errInfo.data.errors);
    }
  };
  try {
    const result = await task();
    checkErrors(result);
    return result;
  } catch (error) {
    if (error instanceof AxiosError) {
      checkErrors(error.response?.data);
    }
    throw error;
  }
};

const zWithErrors = z.object({
  errors: zEntityError.array(),
});
